import { Heading as ChakraHeading } from '@chakra-ui/react'
import { TextProps } from './utils'

const Section = ({ children, color, ...props }: TextProps) => (
  <ChakraHeading as="h2" fontSize="2xl" fontWeight={500} color={color} {...props}>
    {children}
  </ChakraHeading>
)

export { Section }
